export default __webpack_public_path__ + "static/media/0.ca038536.png";